<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Sponsored: "Indicados",
      Username: "Usuário",
      Name: "Nome",
      Date: "Data",
      "E-mail": "E-mail",
      Cellphone: "Celular",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Qualificado",
      Unqualified: "Não Qualificado",
      Left: "Esquerdo",
      Right: "Direito",
      Pending: "Pendente",
      Approved: "Aprovado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
      Graduation: "Graduação",
    },
    es: {
      Sponsored: "Patrocinados",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Date: "Data",
      "E-mail": "E-mail",
      Cellphone: "Celular",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Calificado",
      Unqualified: "No Cualificado",
      Left: "Izquierdo",
      Right: "Derecho",
      Pending: "Pendiente",
      Approved: "Aprobado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
      Graduation: "Graduación",
    },
  },
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      table: {
        heade: [
          "",
          "Username",
          "Name",
          "Date",
          "Cellphone",
          "Plan",
          "Binário",
        ],
        body: null,
        loading: true,
      },

      statData: null,

      binary: {
        modal: false,
        loading: false,
        id: "",
        name: "",
        side: "",
      },
    };
  },
  methods: {
    getSponsoreds() {
      this.table.body = null;

      api
        .get("network/sponsored")
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;

            this.statData = [
              {
                type: "line",
                icon: "bx bx-user",
                title: "Total de Indicados",
                value: response.data.total,
              },
            ];
          }
        })
        .catch(() => {
          this.table.body = [];
        })
    },
    changeBinarySide(row) {
      this.binary.id = row.binary.id;
      this.binary.name = row.name;
      this.binary.side = row.binary.side;

      this.binary.modal = false;
      this.binary.modal = true;
      this.binary.loading = false;
    },
    saveBinarySide() {
      this.binary.loading = true;

      api
        .post('network/binary/side', {
          id: this.binary.id,
          side: this.binary.side
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.modal = false;
            this.binary.loading = false;
            this.$toast.success('O lado de derramamento foi alterado com sucesso!')
            this.getSponsoreds();
          } else {
            this.binary.modal = false;
            this.binary.loading = false;

            this.$toast.error(response.data.message)
          }
        })
        .finally(() => {
          this.binary.loading = false;
        })
    }
  },
  mounted() {
    this.getSponsoreds();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Sponsored') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th v-for="th in table.heade" :key="th">{{ t(th) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(td, index) in table.body" :key="index">
                <td v-for="(data, row) in td" :key="row">
                  <div v-if="row === 'avatar'">
                    <img v-if="data" class="rounded-circle header-profile-user" :src="data" alt="" style="width: 40px; height: 40px" />
                    <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=021229&color=fff&name=' +
                      td.name
                      " alt="" style="width: 40px; height: 40px" />
                  </div>
                  <div v-else-if="row == 'package'">
                    <span class="badge badge-soft-dark font-size-12">{{
                      data
                      }}</span>
                  </div>
                  <div v-else-if="row === 'monthly'">
                    <span v-if="data === 'inactive'" class="badge badge-soft-danger font-size-12">INATIVO</span>
                    <span v-else-if="data === 'active'" class="badge badge-soft-success font-size-12">ATIVO</span>
                  </div>
                  <div v-else-if="row == 'graduation'">
                    <img v-if="data.image" class="rounded-circle header-profile-user" :src="require('@/assets/images/graduations/' + data.image)
                      " alt="" style="width: 40px; height: 40px" />
                    <img v-else class="rounded-circle header-profile-user" src="@/assets/images/logo-icon-app.png" alt="" style="width: 40px; height: 40px" />
                    <span class="badge font-size-12">{{ data.name }}</span>
                  </div>
                  <div v-else-if="row === 'status'">
                    <span v-if="data === 'Pending'" class="badge badge-soft-warning font-size-12">{{ t(data) }}</span>
                    <span v-else-if="data === 'Approved'" class="badge badge-soft-success font-size-12">{{ t(data) }}</span>
                  </div>
                  <div v-else-if="row === 'binary'">
                    <span v-if="data.side === 'l'" class="font-size-12">ESQUERDO</span>
                    <span v-else-if="data.side === 'r'" class="font-size-12">DIREITO</span>
                    –
                    <span v-if="data.status === 'inactive'" class="badge badge-soft-warning font-size-12">INATIVO</span>
                    <span v-else-if="data.status === 'active'" class="badge badge-soft-success font-size-12">ATIVO</span>
                    <template v-if="data.status == 'inactive'">
                      <button class="border-0 bg-white" v-on:click="changeBinarySide(td)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                          <path
                            d="M19.924 10.383a1 1 0 0 0-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15a1 1 0 0 0 .924-.617zM4.076 13.617a1 1 0 0 0 .217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5a.999.999 0 0 0-.924.617z">
                          </path>
                        </svg>
                      </button>
                    </template>
                  </div>
                  <div v-else class="notranslate">
                    {{ data }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal v-model="binary.modal" title="Lado de Derramento" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="saveBinarySide()">
        <h4 class="mb-4">
          {{ binary.name }}
        </h4>
        <b-form-group label="Escolha um lado" label-for="binary.side">
          <select v-model="binary.side" class="custom-select mb-2">
            <option value="l">Lado Esquerdo</option>
            <option value="r">Lado Direto</option>
          </select>
        </b-form-group>
        <b-button class="mb-0" :disabled="this.binary.loading" type="submit" variant="default" size="lg">
          Salvar
          <b-spinner v-if="binary.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </Layout>
</template>
